import GenemodIcon, { IconName } from "@components/GenemodIcon/GenemodIcon";
import { LINKS, LinkType } from "@components/Link/Link";
import classNames from "classnames";
import { Link } from "gatsby";
import React, {
	ButtonHTMLAttributes,
	DetailedHTMLProps,
	HTMLProps,
	useMemo,
} from "react";
import * as styles from "./ButtonV2.module.scss";

type Props = {
	leftIcon?: IconName;
	rightIcon?: IconName;
	className?:string;
	variant?: "primary" | "secondary" | "link" | "v2";
	to?: LinkType;
	mobileFullWidth?: boolean,
	tabletFullWidth?: boolean,
} & DetailedHTMLProps<
	ButtonHTMLAttributes<HTMLButtonElement>,
	HTMLButtonElement
>;

const ButtonV2 = ({
	variant,
	leftIcon,
	rightIcon,
	children,
	disabled,
	to,
	mobileFullWidth,
	tabletFullWidth,
	className,
	...props
}: Props) => {
	const button = (
		<button
			{...props}
			className={classNames(styles.button,className, {
				[styles.disabled]: disabled,
				[styles.secondary]: variant === "secondary",
				[styles.link]: variant === "link",
				[styles.v2]: variant === "v2",
				[styles.mobileWidth]: mobileFullWidth,
				[styles.tabletFullWidth]: tabletFullWidth,
			})}
		>
			{leftIcon && (
				<GenemodIcon
					name={leftIcon}
					style={{ height: 28, width: 28 }}
				/>
			)}
			{children}
			{rightIcon && (
				<GenemodIcon
					name={rightIcon}
					style={{ height: 28, width: 28 }}
				/>
			)}
		</button>
	);
	if (to) {
		return <Link to={LINKS[to].to}>{button}</Link>;
	} else {
		return button;
	}
};

export default ButtonV2;
